//React
import { FunctionComponent } from "react"

//Local Components
import TableRowMenu from "src/components/common/TableRowMenu/TableRowMenu"

//Services
import VIS from "src/pages/vehicle_incidents/VehicleIncidentsService"

interface Props {
    objectId: number
}

const VehicleIncidentsTableBodyTDRowMenu: FunctionComponent<Props> = ({ objectId }) => {
    const { currentView, setIncidentAction, isAuthorizedEventEditor } = VIS

    const canEditEvent = isAuthorizedEventEditor()

    const editLabelsItem = canEditEvent
        ? [{
            icon: "label",
            iconColor: "#198754",
            args: [] as [],
            callBack: () => setIncidentAction({ action: 8, id: objectId }),
            hoverText: "Edit Labels"
        }]
        : []

    const editEmployeeItem = canEditEvent
        ? [{
            icon: "person",
            iconColor: "#0d6efd",
            args: [] as [],
            callBack: () => setIncidentAction({ action: 9, id: objectId }),
            hoverText: "Edit Employee"
        }]
        : []

    if (currentView === -1) {
        // Case 1: NEW — show only Ignore + Take Action
        return (
            <TableRowMenu
                items={[
                    ...editLabelsItem,
                    ...editEmployeeItem,
                    {
                        icon: "picture_as_pdf",
                        iconColor: "#6610f2",
                        args: [],
                        callBack: () => setIncidentAction({ action: 7, id: objectId }),
                        hoverText: "Generate PDF"
                    },
                    {
                        icon: "close",
                        iconColor: "#dc3545",
                        args: [],
                        callBack: () => setIncidentAction({ action: 5, id: objectId }),
                        hoverText: "Ignore"
                    },
                    {
                        icon: "arrow_right_alt",
                        iconColor: "#000000",
                        args: [],
                        callBack: () => setIncidentAction({ action: 1, id: objectId }),
                        hoverText: "Take action"
                    }
                ]}
            />
        )
    }

    if (currentView === 1) {
        // Case 2: PENDING — show all 3 options
        return (
            <TableRowMenu
                items={[
                    ...editLabelsItem,
                    ...editEmployeeItem,
                    {
                        icon: "picture_as_pdf",
                        iconColor: "#6610f2",
                        args: [],
                        callBack: () => setIncidentAction({ action: 7, id: objectId }),
                        hoverText: "Generate PDF"
                    },
                    {
                        icon: "visibility_off",
                        iconColor: "#dc3545",
                        args: [],
                        callBack: () => setIncidentAction({ action: 5, id: objectId }),
                        hoverText: "Ignore"
                    },
                    {
                        icon: "arrow_right_alt",
                        iconColor: "#000000",
                        args: [],
                        callBack: () => setIncidentAction({ action: 1, id: objectId }),
                        hoverText:
                            "Start discipline or forward event to next reviewer."
                    },
                    {
                        icon: "timeline",
                        iconColor: "#17a2b8",
                        args: [],
                        callBack: () => setIncidentAction({ action: 6, id: objectId }),
                        hoverText: "View History"
                    }
                ]}
            />
        )
    }

    // Case 3: Anything else — just show View History
    return (
        <TableRowMenu
            items={[
                ...editLabelsItem,
                ...editEmployeeItem,
                {
                    icon: "picture_as_pdf",
                    iconColor: "#6610f2",
                    args: [],
                    callBack: () => setIncidentAction({ action: 7, id: objectId }),
                    hoverText: "Generate PDF"
                },
                {
                    icon: "timeline",
                    iconColor: "#17a2b8",
                    args: [],
                    callBack: () => setIncidentAction({ action: 6, id: objectId }),
                    hoverText: "View History"
                }
            ]}
        />
    )
}

export default VehicleIncidentsTableBodyTDRowMenu
